/**
 * SearchSmsMixin
 */

export default {
    data () {
        return {
            searchText:        '',
            elemHighlighted:   null,
            elemHighligh:      null,
            arrowBtnActivated: false,
            CountsearchResult: 0
        };
    },

    methods: {

        /**
         * Text Search changed
         */
        txtSearchChange (text) {
            window.scrollTo(0, document.getElementsByClassName('sms-chat').scrollHeight);
            this.deleteHighlightText();
            if (text !== '') {
                this.CountsearchResult = 0;
                this.searchText = text;
                const inputText = document.getElementsByClassName('text-message');
                Array.from(inputText).forEach((el) => {
                    let innerHTML = el.innerHTML;
                    const index = innerHTML.toUpperCase().indexOf(text.toUpperCase());
                    if (index >= 0) {
                        this.CountsearchResult++;
                        innerHTML = `${innerHTML.substring(0, index)}<span class='highlight'>${innerHTML.substring(index, index + text.length)}</span>${innerHTML.substring(index + text.length)}`;
                        el.innerHTML = innerHTML;
                        document.getElementsByClassName('text-message').innerHTML = innerHTML;
                    }
                    return el;
                });

                if (this.CountsearchResult > 0) {
                    const highlightedElements = Array.from(document.getElementsByClassName('highlight')).sort((element1, element2) => element1.getBoundingClientRect().top - element2.getBoundingClientRect().top);
                    highlightedElements[this.CountsearchResult - 1].scrollIntoView({ behavior: 'smooth' });
                    highlightedElements[this.CountsearchResult - 1].parentElement.classList.add('active');
                }
                this.elemHighlighted = this.CountsearchResult;
            }
        },

        /**
         * Delete Class Active
         */
        removeClassActive () {
            document.getElementsByClassName('highlight').forEach((element) => {
                element.parentElement.classList.remove('active');
            });
        },

        /**
         * Show the previous result
         */
        previousResultClick () {
            this.arrowBtnActivated = true;
            this.removeClassActive();
            if (
                (this.elemHighlighted === 1 || this.elemHighlighted === null)
                || ((this.elemHighligh === 0 || this.elemHighligh === null))
            ) {
                this.elemHighlighted = this.CountsearchResult;
                this.elemHighligh = this.CountsearchResult - 1;
            } else {
                this.elemHighlighted = this.elemHighlighted - 1;
                this.elemHighligh = this.elemHighligh - 1;
            }
            const highlightedElements = Array.from(document.getElementsByClassName('highlight')).sort((element1, element2) => element1.getBoundingClientRect().top - element2.getBoundingClientRect().top);
            highlightedElements[this.elemHighligh]?.parentElement.classList.add('active');
            highlightedElements[this.elemHighligh]?.parentElement.scrollIntoView({ behavior: 'smooth' });
        },

        /**
         * Show next result
         */
        nextResultClick () {
            this.arrowBtnActivated = true;
            this.removeClassActive();
            if (
                (this.elemHighlighted === this.CountsearchResult || this.elemHighlighted === null)
                || ((this.elemHighligh === this.CountsearchResult - 1 || this.elemHighligh === null))) {
                this.elemHighlighted = 1;
                this.elemHighligh = 0;
            } else {
                this.elemHighlighted = this.elemHighlighted + 1;
                this.elemHighligh = this.elemHighligh + 1;
            }
            const highlightedElements = Array.from(document.getElementsByClassName('highlight')).sort((element1, element2) => element1.getBoundingClientRect().top - element2.getBoundingClientRect().top);
            highlightedElements[this.elemHighligh]?.parentElement.classList.add('active');
            highlightedElements[this.elemHighligh]?.parentElement.scrollIntoView({ behavior: 'smooth' });
        },

        /**
         * Deactivate the highlight of the text
         */
        deleteHighlightText () {
            this.searchText = '';
            const inputText = document.getElementsByClassName('text-message');
            Array.from(inputText).forEach((el) => {
                let innerHTML = el.innerHTML;
                const leng = '<span class="highlight">'.length;
                const index = innerHTML.indexOf('<span class="highlight">');
                const indexClose = innerHTML.indexOf('</span>');
                const lengCloseSpan = '</span>'.length;
                const textHighlghted = innerHTML.substring(index + leng, indexClose + lengCloseSpan);
                if (index >= 0) {
                    innerHTML = `${innerHTML.substring(0, index)}${textHighlghted}${innerHTML.substring(indexClose + lengCloseSpan)}`;
                    el.innerHTML = innerHTML;
                    document.getElementsByClassName('text-message').innerHTML = innerHTML;
                }
                return el;
            });
            this.ResetValues();
        },

        /**
         * Reset Values
         */
        ResetValues () {
            this.CountsearchResult = 0;
            this.elemHighlighted = '';
        }

    }
};
